import { render } from "./RevenueChart.vue?vue&type=template&id=491016fa"
import script from "./RevenueChart.vue?vue&type=script&lang=js"
export * from "./RevenueChart.vue?vue&type=script&lang=js"

import "./RevenueChart.vue?vue&type=style&index=0&id=491016fa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__